// Merge cached feedback with a newly fetched slice, removing duplicates by _id.
// Later entries overwrite earlier ones with the same _id (harmless, same doc).
export function mergeFeedbackData(existing, incoming) {
  const map = new Map();
  [...(existing || []), ...(incoming || [])].forEach((item) => {
    if (item && item._id != null) map.set(item._id, item);
  });
  return Array.from(map.values());
}
